import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper.ts";
import { modulatorLinkApplianceDto } from "@/types/backoffice/dto/modulator/modulator-link-appliance-dto.ts";

export const modulatorLinkDto = z.object({
  csId: branded.modulatorLinkCsId,
  csLinkToCutId: branded.modulatorLinkCsId.nullable(),
  cutLink: z.boolean(),
  measureIndex: z.number(),
  measureType: z.number(),
  hwId: branded.modulatorLinkHwId,
  interfaceName: z.string().nullable(),
  appliances: z.array(modulatorLinkApplianceDto),
});

export type TModulatorLinkDto = z.infer<typeof modulatorLinkDto>;
